import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { SkillGapInsights } from '../component/templates/SkillGapInsights'

export const MyTeamSkillGapsPage = observer(() => {
  const { skillName } = useParams<{ skillName?: string }>()

  return (
    <Box sx={styles.root}>
      <SkillGapInsights skillName={skillName} />
    </Box>
  )
})

const styles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: 20,
  },
}
